import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import { docTypeIcons } from "./documentTypes";
import documentTypes from "./documentTypes";
import get from "lodash/get";
import { styled } from "@mui/material";

const AttachmentCell = styled(TableCell)({
    fontSize: 14,
});

const Sortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

// const Download = styled(Box)({
//     cursor: "pointer",
//     float: "right",
// });

// const MissingDocs = styled(Box)({
//     color: "red",
// });

const DocumentPropertyManagementSnapshot = (props) => {
    const { viewDocument, savedDocuments } = props;

    const [docMenuKey, setDocMenuKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenDocumentMenu = (docKey, anchorEl) => {
        setAnchorEl(anchorEl);
        setDocMenuKey(docKey);
    };

    const handlePreviewDocument = (url, docKey) => {
        setAnchorEl(null);
        viewDocument(url, docKey);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const columnDefs = [
        { display: "Name", prop: "mediaAssetName" },
        { display: "Document Type", prop: "mediaAssetType" },
        { display: "" },
    ];
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {columnDefs.map((x, i) => (
                        <TableCell key={`doc-head-${i}`}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Sortable>{x.display}</Sortable>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(savedDocuments).map((x, i) => {
                    const document = savedDocuments[x];
                    const docType = get(document, "mediaAssetType", "");
                    const docTypeName = get(documentTypes.propertyManagement[docType], "display", "");
                    return (
                        <TableRow key={`tr-doc-${i}`}>
                            <AttachmentCell>
                                {get(
                                    docTypeIcons,
                                    get(document, "mediaAssetName", " ")
                                        .split(".")
                                        .pop()
                                        .toLowerCase(),
                                    docTypeIcons["default"]
                                )()}
                                <span>{document["mediaAssetName"]}</span>
                            </AttachmentCell>
                            <TableCell>
                                <div>{docTypeName}</div>
                            </TableCell>
                            <TableCell>
                                <div>
                                    <IconButton
                                        disabled={false}
                                        aria-label="More"
                                        aria-owns={Boolean(document["anchorEl"]) ? `long-menu-${x}-${i}` : null}
                                        aria-haspopup="true"
                                        onClick={(e) => handleOpenDocumentMenu(document.mediaAssetKey, e.currentTarget)}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        id="long-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={() => handleMenuClose()}
                                        PaperProps={{
                                            style: {
                                                width: 200,
                                            },
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() =>
                                                handlePreviewDocument(get(document, "url", null), docMenuKey)
                                            }
                                        >
                                            Open in a new tab
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default DocumentPropertyManagementSnapshot;
